import api from './api'

export const vendorsService = {
  async getAllVendors() {
    return await api.get('/vendors')
  },

  async getVendorById(id) {
    return await api.get(`/vendors/${id}`)
  },

  async getVendorSales(vendor, page = 1) {
    return await api.get(`/vendors/${vendor}?page=${page}`)
  },

  async getUnassignedSales() {
    return await api.get(`/vendors/other`)
  }
} 